module.exports = __webpack_public_path__ + "media/images/page/lp-sample_large3-fc87ef5aaedbc42153e673f2e23f8140.jpg";